function track(id, name) {
  if (window.PTTSendClick) {
    window.PTTSendClick('btn', id, name)
  }
}

export default track
